import React, {useContext} from 'react';
import "../map/CrimeMap.css";
import FilterPanel from './FilterPanel';
import FilterContext from "../FilterContext";
import {Container, Table, TableBody, TableCell, TableContainer, TableRow} from "@material-ui/core";

const addRow = (rows, key, value, lambda) => {
    if (value) {
        rows.push({key, value: lambda(value)});
    }
}

export const SummaryInfo = ({sidebarWidth, selected, close}) => {
    return (
        <FilterPanel sidebarWidth={sidebarWidth} selected={selected} close={close}>
            <Container>
                <h3>Filter Summary</h3>
                <FilterSummary/>
                <br/>
                <br/>
                <h3>Result Summary</h3>
                <ResultSummary/>
                <CADResultSummary/>
            </Container>
        </FilterPanel>
    )
}

const NoFilters = () => {
    return (
        <TableContainer>
            <Table>
                <TableBody>
                    <TableRow>
                        <TableCell>No Applied Filters</TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        </TableContainer>
    )
}

const FilterSummary = () => {
    const [{filters, shapes}] = useContext(FilterContext);

    const rows = []
    addRow(rows, "Start Date", filters.start, date => new Date(date).toLocaleDateString());
    addRow(rows, "End Date", filters.end, date => new Date(date).toLocaleDateString());
    addRow(rows, "Crime Types", filters.crimeType, types => types.join(", "));
    addRow(rows, "Region", filters.shapeId, id => shapes.shapes.find(it => it.id === id).name);
    addRow(rows, "Status", filters.acFlag, val => val);
    addRow(rows, "Arrest Made", filters.hasArrestee, val => val === 'Y' ? "Yes" : 'No');
    addRow(rows, "Juvenile Offender", filters.juvenileOffender, val => val === 'Y' ? "Yes" : 'No');

    return rows.length === 0 ? <NoFilters/> :
        <TableContainer>
            <Table>
                <TableBody>
                    {rows.map(row => (
                        <TableRow key={row.key}>
                            <TableCell>{row.key}</TableCell>
                            <TableCell>{row.value}</TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
}

const NoResults = () => {
    return (
        <TableContainer>
            <Table>
                <TableBody>
                    <TableRow>
                        <TableCell>No Incidents Found</TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        </TableContainer>
    )
}

const NoResultsCAD = () => {
    return (
        <TableContainer>
            <Table>
                <TableBody>
                    <TableRow>
                        <TableCell>No Calls Found</TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        </TableContainer>
    )
}

const ResultSummary = () => {
    const [{results}] = useContext(FilterContext);

    if (!results || !results.features) return "";

    const row = (key, value, lambda) => ({key, value: lambda(value)});

    const rows = [
        // TODO move 200 to API call
        row("Incidents", results.features.length, count => count === 200 ? "Max Results (200)" : count)
    ];

    return rows.length === 0 ? <NoResults/> :
        <TableContainer>
            <Table>
                <TableBody>
                    {rows.map(row => (
                        <TableRow key={row.key}>
                            <TableCell>{row.key}</TableCell>
                            <TableCell align='right'>{row.value}</TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
}


const CADResultSummary = () => {
    const [{calls}] = useContext(FilterContext);
    if (!calls || !calls.features) {
        return "";
    }
    const row = (key, value, lambda) => ({key, value: lambda(value)});

    const rows = [
        // TODO move 200 to API call
        row("Calls", calls.features.length, count => count === 200 ? "Max Results (200)" : count)
    ];

    return rows.length === 0 ? <NoResultsCAD/> :
        <TableContainer>
            <Table>
                <TableBody>
                    {rows.map(row => (
                        <TableRow key={row.key}>
                            <TableCell>{row.key}</TableCell>
                            <TableCell align='right'>{row.value}</TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
}

export default SummaryInfo;
